import type { CSSObject } from 'tss-react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

export const scrollBarStyles: CSSObject = {
  '&::-webkit-scrollbar': {
    width: '5px',
    height: '5px',
    borderRadius: '12px',
    backgroundColor: patientAccessTheme.palette.primary.light,
  },
  '&::-webkit-scrollbar-track': {
    background: patientAccessTheme.palette.grey[300],
    borderRadius: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: patientAccessTheme.palette.grey[500],
    borderRadius: '12px',
  },
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const MONTH_YEAR_FORMAT = 'MMMM - YYYY';

export const COMMON_TEXTS = {
  FOR: 'for ',
};
